import AxiosClient from "../../services/axios.services";

class EmployeesServices {
  getAllEmployees = (filter) =>
    AxiosClient.get("/api/app/Funcional_empleado_lista_sencilla/", {
      headers: { "Content-Type": "application/json" },
      params: filter,
    });
  getAllActiveEmployees = (filter) =>
    // AxiosClient.get("/api/app/Funcional_empleado_activos_lista_sencilla_sanciones/", {
    AxiosClient.get(
      "/api/app/Funcional_empleado_activos_lista_sencilla_sanciones/",
      {
        headers: { "Content-Type": "application/json" },
        params: filter,
      }
    );
  mailSendRequirementsMonitor = (data) =>
    AxiosClient.post(`/api/app/envio_correo_seleccion_contratacion/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  dadoBajaHeadClima = (data) =>
    AxiosClient.post(
      `/api/app/actualizar_dato_dado_baja_head_clima_a_onboarding/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new EmployeesServices();
